
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Search',
  // Mis datos
  data: () => ({
    // input Ciudad
    inputCity: '',
  }),
  // Propiedades computadas
  computed: {
    // Desactiva el buscador
    searchDisabled(): boolean {
      return !this.inputCity;
    },
    // Limpia el buscador
    clearDisabled(): boolean {
      return !this.inputCity;
    },
  },
  // Mis métodos
  methods: {
    // lanza el evento search-city con el valor de inputCity
    searchCity() {
      this.$emit('search-city', this.inputCity);
    },
    // limpia el inputCity
    clearCity() {
      // this.$emit('reset-city')
      this.inputCity = '';
    },
  },
});
